const inFlightRequests = new Map();

export const getInFlightRequest = (key) => inFlightRequests.get(key) || null;

export const setInFlightRequest = (key, request) => {
  inFlightRequests.set(key, {
    ...request,
    subscribers: 0
  });
};

export const retainInFlightRequest = (key) => {
  const current = inFlightRequests.get(key);
  if (!current) {
    return null;
  }

  current.subscribers += 1;
  return current;
};

export const releaseInFlightRequest = (key, request) => {
  const current = inFlightRequests.get(key);
  if (current === request) {
    current.subscribers = Math.max(0, current.subscribers - 1);
    if (current.subscribers === 0 && current.settled) {
      inFlightRequests.delete(key);
    }
  }
};

export const settleInFlightRequest = (key, request) => {
  const current = inFlightRequests.get(key);
  if (current === request) {
    current.settled = true;
    if (current.subscribers === 0) {
      inFlightRequests.delete(key);
    }
  }
};

export const clearAllInFlightRequests = () => {
  inFlightRequests.clear();
};
